import React, { useEffect } from "react";

// Components
import TextInput from "components/input/TextInput";
import SelectInput from "components/input/SelectInput";
import MultipleSelectInput from "components/input/MultipleSelectInput";

// Data
import { countries, languages } from "utils/constants";
import { diversities } from "utils/constants/data";

function LanguageCulturalDiversity({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleBlur,
}) {
  const handleSelectOptions = (data) => {
    const options = data.map((el) => {
      return {
        id: el.value,
        text: el.label,
      };
    });

    return options;
  };

  useEffect(() => {
    if (values.is_born_australian) {
      setFieldValue("other_birth_country", "");
    }
    if (values.is_only_speak_english) {
      setFieldValue("other_speech_language", []);
    }
  }, [values.is_born_australian, values.is_only_speak_english]);

  return (
    <div className="bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <p className="uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold">
        Language and Cultural Diversity
      </p>
      <hr className="h-1 border-none text-[#333] bg-[#333]" />
      <p className="uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold">
        9. In which country you were born?
      </p>
      <div className="flex flex-row items-center space-x-3">
        <div>
          <input
            checked={values.is_born_australian === true}
            id={`birth-country-checkbox-btn`}
            name={`birth-country`}
            type="checkbox"
            onChange={() =>
              setFieldValue(`is_born_australian`, !values.is_born_australian)
            }
            value={values.is_born_australian}
            className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
          />
        </div>
        <p className="text-base xl:text-lg">1101 – Australia</p>
      </div>
      {values.is_born_australian === false && (
        <SelectInput
          name="other_birth_country"
          classNameInput="text-base xl:text-lg"
          label="Other Country – Please Specify:"
          options={handleSelectOptions(countries)}
          placeholder="Select country..."
          onChange={handleChange}
          onBlur={handleBlur}
          error={
            errors?.other_birth_country &&
            touched?.other_birth_country &&
            errors.other_birth_country
          }
          value={values.other_birth_country}
        />
      )}
      <p className="uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold">
        10. Do you speak a language other than english at home?
      </p>
      <p className="text-sm xl:text-base">
        If more than one language, indicate the one that is spoken most often.
      </p>
      <div className="flex flex-row items-center space-x-3">
        <div>
          <input
            checked={values.is_only_speak_english === true}
            id={`speech-language-checkbox-btn`}
            name={`speech-language`}
            type="checkbox"
            onChange={() =>
              setFieldValue(
                `is_only_speak_english`,
                !values.is_only_speak_english
              )
            }
            value={values.is_only_speak_english}
            className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
          />
        </div>
        <p className="text-base xl:text-lg">1201 – No, English Only</p>
      </div>
      {values.is_only_speak_english === false && (
        <MultipleSelectInput
          name="other_speech_language"
          classNameInput="text-base xl:text-lg"
          label="Yes, Other Language – Please Specify:"
          options={languages}
          placeholder="Select languages..."
          setFieldValue={setFieldValue}
          onBlur={handleBlur}
          error={
            errors?.other_speech_language &&
            touched?.other_speech_language &&
            errors.other_speech_language
          }
          value={values.other_speech_language}
        />
      )}
      {values.other_speech_language.length > 0 && (
        <SelectInput
          name="english_proficiency"
          classNameInput="text-base xl:text-lg"
          label="English Proficiency:"
          options={[
            {
              id: "Not specified",
              text: "Not specified",
            },
            {
              id: "Very well",
              text: "Very well",
            },
            {
              id: "Well",
              text: "Well",
            },
            {
              id: "Not well",
              text: "Not well",
            },
            {
              id: "Not at all",
              text: "Not at all",
            },
          ]}
          placeholder="Select..."
          onChange={handleChange}
          onBlur={handleBlur}
          error={
            errors?.english_proficiency &&
            touched?.english_proficiency &&
            errors.english_proficiency
          }
          value={values.english_proficiency}
        />
      )}
      <p className="uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold">
        11. Are you of aboriginal or torres strait islander origin?
      </p>
      <p className="text-sm xl:text-base">
        For persons of both Aboriginal and Torres Strait Islander origin, mark
        both "Yes" boxes.
      </p>
      <div className="flex flex-col space-y-2">
        <div className="flex flex-col space-y-4">
          {diversities.map((diversity, i) => {
            return (
              <div className="flex flex-row items-center space-x-3">
                <div>
                  <input
                    checked={values.cultural_origins === diversity.title}
                    id={`culture-origin-radio-btn-${i}`}
                    name={`culture-origin-${i}`}
                    type="radio"
                    onChange={() =>
                      setFieldValue(`cultural_origins`, diversity.title)
                    }
                    value={values.cultural_origins}
                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                  />
                </div>
                <p className="text-base xl:text-lg" key={i}>
                  {diversity.title}
                </p>
              </div>
            );
          })}
        </div>
        {errors?.cultural_origins &&
          touched?.cultural_origins &&
          errors.cultural_origins && (
            <p className="text-xs sm:text-sm xl:text-base text-red-500">
              {errors.cultural_origins}
            </p>
          )}
      </div>
    </div>
  );
}

export default LanguageCulturalDiversity;
